import { Booking } from '@/models/booking.model';
import { cloneDeep } from 'lodash';
import { GetterTree, ActionTree, MutationTree, ActionContext } from 'vuex';

interface LoadingState {
  courseBooking: Booking | null;
  courseBookingIncludedArray: any[];
}

export const defaultCourseBookingState: LoadingState = {
  courseBooking: null,
  courseBookingIncludedArray: []
};

const state: LoadingState = cloneDeep(defaultCourseBookingState);

const mutations: MutationTree<LoadingState> = {
  ADD_COURSE_BOOKING(returnedState: LoadingState, payload: { booking: Booking; includedArray: any[] }): void {
    returnedState.courseBooking = payload.booking;
    returnedState.courseBookingIncludedArray = payload.includedArray;
  },
  REMOVE_COURSE_BOOKING(returnedState: LoadingState): void {
    returnedState.courseBooking = null;
    returnedState.courseBookingIncludedArray = [];
  }
};

const actions: ActionTree<LoadingState, {}> = {
  addBooking: (
    { commit }: ActionContext<LoadingState, {}>,
    payload: { booking: Booking; includedArray: any[] }
  ): void => {
    commit('ADD_COURSE_BOOKING', payload);
  },
  removeBooking: ({ commit }: ActionContext<LoadingState, {}>): void => {
    commit('REMOVE_COURSE_BOOKING');
  }
};

const getters: GetterTree<LoadingState, {}> = {
  courseBooking: (returnedState: LoadingState): Booking | null => {
    return returnedState.courseBooking;
  },
  courseBookingIncludedArray: (returnedState: LoadingState): any[] => {
    return returnedState.courseBookingIncludedArray;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
